module.exports = {
  spinButtonVisible: true,
  winFieldCountDuration: 1500,
  popupScreen: null,
  autoPlayReStart: false,
  enableSpinRingAnimation: true,
}
